module.exports = __webpack_public_path__ + "img/HotFudgeSundae.d022157c.webp";